import { render, staticRenderFns } from "./PatientCalendarRouteHeader.vue?vue&type=template&id=680683bc&scoped=true&"
import script from "./PatientCalendarRouteHeader.vue?vue&type=script&lang=ts&"
export * from "./PatientCalendarRouteHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PatientCalendarRouteHeader.vue?vue&type=style&index=0&id=680683bc&lang=scss&scoped=true&"
import style1 from "./PatientCalendarRouteHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680683bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VImg,VList,VListItem,VListItemTitle,VMenu,VRow,VSpacer})
